import { combineReducers } from "redux";
import transferHistoryReducer from "./TransferReducer";
import bankDetailsReducer from "./BankDetailsReducer";
import maxPayoutReducer from "./MaxPayoutReducer";
import payoutBankReducer from "./PayoutBankReducer";
export default combineReducers({
    transferHistoryReducer: transferHistoryReducer,
    bankDetailsReducer: bankDetailsReducer,
    maxPayoutReducer: maxPayoutReducer,
    payoutBankReducer: payoutBankReducer,
});
